/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Never_LabelInputs */

const es_privacy_policy_sharing_never_label = /** @type {(inputs: Privacy_Policy_Sharing_Never_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca`)
};

const en_privacy_policy_sharing_never_label = /** @type {(inputs: Privacy_Policy_Sharing_Never_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Privacy_Policy_Sharing_Never_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_never_label = /** @type {((inputs?: Privacy_Policy_Sharing_Never_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Never_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_never_label(inputs)
	return en_privacy_policy_sharing_never_label(inputs)
});
export { privacy_policy_sharing_never_label as "privacy_policy.sharing.never_label" }